import PropTypes from 'prop-types';
import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { DropdownArrow, DropdownUpArrow, DashboardExpand, } from "../../../assets/icons";
import "../dashboard-real-estate/dashboard-real-estate.scss";

const WorklogButtonRow = ({
  member,
  toggled,
  showModal,
  toggleAccordion,
  accordionId,
  setToggled,
  setCollapsed,
  getCollapsedStatus
}) => {
    let isToggled = toggled?.filter(t => t.UserId == member.UserId)?.[0]?.Toggled ?? false;
    let allDisabled = member?.WorklogTracker[0]?.TableWorklog?.length === 0;

    const commonButtons = (
      <OverlayTrigger
        placement="top"
        overlay={<Tooltip>Expand {member.Name}</Tooltip>}
      >
        { !allDisabled ?
            <img alt="dropdown-arrow" src={DashboardExpand} onClick={() => showModal(member)} />
          :
            <img disabled alt="dropdown-arrow" src={DashboardExpand} />
        }
      </OverlayTrigger>
    );

    if (allDisabled) {
      return (
        <td className="col-md-1 mt-2">
          <div className="real-estate-button-row float-right">
            {commonButtons}
            <img className="real-estate-dropdown-arrow" disabled alt="dropdown-arrow" src={DropdownArrow} />
          </div>
        </td>
      );
    }
    return (
      <td className="col-md-1 mt-2 real-estate-toogle">
        <div className="real-estate-button-row float-right">
          {commonButtons}
          <img className="real-estate-dropdown-arrow"
            alt="dropdown-arrow"
            src={isToggled ? DropdownUpArrow : DropdownArrow}
            onClick={(e) => {
              let updatedToggled = toggled.map((t) => {
                if (t.UserId == member.UserId) t.Toggled = !isToggled;
                return t;
              });
              toggleAccordion(accordionId + "-" + member.UserId);
              setToggled(updatedToggled);
              setCollapsed(getCollapsedStatus(accordionId));
            }}
          />
        </div>
      </td>
    );
};

WorklogButtonRow.propTypes = {
    member: PropTypes.shape({
        UserId: PropTypes.number.isRequired,
        Name: PropTypes.string,
        WorklogTracker: PropTypes.arrayOf(PropTypes.shape({
          ProjectId: PropTypes.number.isRequired,
          ProjectsName: PropTypes.string,
          AllowWorklogEdit: PropTypes.bool.isRequired,
          TableWorklog: PropTypes.array.isRequired,
        })),
    }).isRequired,
    toggled: PropTypes.arrayOf(
        PropTypes.shape({
            UserId: PropTypes.number.isRequired,
            Toggled: PropTypes.bool.isRequired,
        })
    ).isRequired,
    showModal: PropTypes.func.isRequired,
    toggleAccordion: PropTypes.func.isRequired,
    accordionId: PropTypes.string.isRequired,
    setToggled: PropTypes.func.isRequired,
    setCollapsed: PropTypes.func.isRequired,
    getCollapsedStatus: PropTypes.func.isRequired,
};

export default WorklogButtonRow;
